/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import pptxgen from "pptxgenjs";
import { DateRangePicker } from 'react-date-range';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import 'react-date-range/dist/styles.css'; // main react-date-range css file
import 'react-date-range/dist/theme/default.css'; // theme react-date-range css file
import './dashboard.css';
import { COMMON, DASHBOARD_SCREEN, DATE_FORMATS, API_CONSTANTS, ALL_ROUTES, CALENDER_SCREEN, PERMISSION_CONSTANTS } from '../../global/Constants';
import Header from '../common/Header';
import Footer from '../common/Footer';
import DesktopFooter from '../common/DesktopFooter';
import DashboardActivity from './DashboardActivity';
import DashboardUsers from './DashboardUsers';
import DashboardTehsils from './DashboardTehsils';
import DashboardHybrids from './DashboardHybrids';
import { DashboardType, HeaderTypes, RangeType } from "../../global/Enum";
import ApiServices from "../../providers/ApiServices";
import Utilities from '../../global/Utilities';
import Loader from "../common/loader/Loader";
import SyncLoader from '../common/loader/SyncLoader';
import PDFReport from './PDFReport';
import AuthService from '../../providers/AuthService';


class DashboardPage extends Component {
    constructor(props) {
        super(props);
        this.role_id = 0;
        this.role_name = "All";
        this.startDate = null;
        this.endDate = null;

        this.state = {
            isLoading: false,
            showDatePicker: false,
            activeTab: DashboardType.ACTIVITIES,
            activeRange: RangeType.LAST_MONTH,
            disableNextButton: true,
            selectionRange: {
                startDate: new Date(),
                endDate: new Date(),
                //endDate: addDays(new Date(), 7),
                key: 'selection',
            },
            selectedTM: "All TM",
            selectedDateOption: DASHBOARD_SCREEN.LAST_30_DAYS,
            startDate: moment().subtract(30, 'days'),
            endDate: moment().subtract(0, 'days'),
            errorMsg: '',

            activityData: {},
            userData: null,
            tehsilData: null,
            hybridData: null,
            data: {},
            allTMUsers: [],

            downloadOptions: [
                { id: 1, value: "Dashboard PPT", isChecked: false },
                { id: 2, value: "Dashboard PDF", isChecked: false },
            ]
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            const { startDate, endDate } = this.state;

            //this.getDashboardData(this.startDate, this.endDate);
            this.getDashboardMasterData(startDate, endDate);

        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }
    }

    dateFormat = (date) => {
        return moment(date).format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
    }

    // Get Master Data
    getDashboardMasterData = (startDate, endDate) => {
        if (Utilities.isNetworkConnected()) {
            this.setState({ isLoading: true });
            var request = JSON.stringify({
                start_date: this.dateFormat(startDate),
                end_date: this.dateFormat(endDate),
                role_id: this.role_id
            });

            Utilities.LogPrint("Request", request);
            try {
                ApiServices.getDashboardMasterData(request)
                    .then(response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        if (response.success) {

                            this.setState({
                                data: response.data,
                            });

                            if (response.data?.role.length > 0) {
                                const newArrayOfObj = response.data?.role.map(({ role_id: value, role_name: label, ...rest }) => ({ value, label, ...rest }));
                                //Utilities.LogPrint("Role Data", newArrayOfObj);
                                this.setState({ allTMUsers: newArrayOfObj })
                            }

                            if (response.data?.role.length === 1) {
                                this.role_name = "Self";
                            }
                            this.getActiveTabData();

                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false, errorMsg: error });
                    });
            } catch (error) {
                this.setState({ isLoading: false, errorMsg: error });
            }
        }
    }

    // Get Activity Data
    getDashboardActivityData = async (startDate, endDate) => {
        if (Utilities.isNetworkConnected()) {
            this.setState({ isLoading: true });
            var request = JSON.stringify({
                start_date: this.dateFormat(startDate),
                end_date: this.dateFormat(endDate),
                role_id: this.role_id
            });

            Utilities.LogPrint("Request", request);
            try {
                ApiServices.getDashboardActivityData(request)
                    .then(response => {
                        Utilities.LogPrint("getDashboardActivityData: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {

                            this.setState({
                                activityData: response.data?.activity,
                            });

                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false, errorMsg: error });
                    });
            } catch (error) {
                this.setState({ isLoading: false, errorMsg: error });
            }
        }
    }

    // Get Users Data
    getDashboardUserData = async (startDate, endDate) => {

        if (Utilities.isNetworkConnected()) {
            this.setState({ isLoading: true });
            var request = JSON.stringify({
                start_date: this.dateFormat(startDate),
                end_date: this.dateFormat(endDate),
                role_id: this.role_id
            });

            Utilities.LogPrint("Request", request);
            try {
                ApiServices.getDashboardUserData(request)
                    .then(response => {
                        Utilities.LogPrint("getDashboardUserData: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {

                            this.setState({
                                userData: response.data?.user_activity,
                            });

                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false, errorMsg: error });
                    });
            } catch (error) {
                this.setState({ isLoading: false, errorMsg: error });
            }
        }
    }

    // Get Tehsil Data
    getDashboardTehsilData = async (startDate, endDate) => {

        if (Utilities.isNetworkConnected()) {
            this.setState({ isLoading: true });
            var request = JSON.stringify({
                start_date: this.dateFormat(startDate),
                end_date: this.dateFormat(endDate),
                role_id: this.role_id
            });

            Utilities.LogPrint("Request", request);
            try {
                ApiServices.getDashboardTehsilData(request)
                    .then(response => {
                        Utilities.LogPrint("getDashboardTehsilData: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {

                            this.setState({
                                tehsilData: response.data?.tehsil,
                            });

                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false, errorMsg: error });
                    });
            } catch (error) {
                this.setState({ isLoading: false, errorMsg: error });
            }
        }
    }

    // Get Hybrid Data
    getDashboardHybridData = async (startDate, endDate, hybridId) => {

        if (Utilities.isNetworkConnected()) {
            this.setState({ isLoading: true });
            var request = JSON.stringify({
                start_date: this.dateFormat(startDate),
                end_date: this.dateFormat(endDate),
                hybrid_id: hybridId
            });

            Utilities.LogPrint("Request", request);
            try {
                ApiServices.getDashboardHybridData(request)
                    .then(response => {
                        this.setState({ isLoading: false });
                        Utilities.LogPrint("getDashboardActivityData: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {

                            this.setState({
                                hybridData: response.data?.hybrid[0],
                            });

                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false, errorMsg: error });
                    });
            } catch (error) {
                this.setState({ isLoading: false, errorMsg: error });
            }
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    // getDashboardData = (startDate, endDate) => {
    //     if (Utilities.isNetworkConnected()) {
    //         this.setState({ isLoading: true });
    //         var request = JSON.stringify({
    //             start_date: startDate,
    //             end_date: endDate,
    //             role_id: this.role_id
    //         });

    //         Utilities.LogPrint("Request", request);
    //         try {
    //             ApiServices.getDashboardData(request)
    //                 .then(response => {
    //                     Utilities.LogPrint("API_DATA: ---->", response);
    //                     this.setState({ isLoading: false });
    //                     if (response.success) {

    //                         this.setState({
    //                             data: response.data,
    //                         });

    //                         if (response.data?.role.length > 0) {
    //                             const newArrayOfObj = response.data?.role.map(({ role_id: value, role_name: label, ...rest }) => ({ value, label, ...rest }));
    //                             //Utilities.LogPrint("Role Data", newArrayOfObj);
    //                             this.setState({ allTMUsers: newArrayOfObj, isLoading: false })
    //                         }

    //                         if (response.data?.role.length === 1) {
    //                             this.role_name = "Self";
    //                         }

    //                     } else {
    //                         if (response.message === COMMON.TOKEN_EXPIRED) {
    //                             Utilities.tokenExpiredRedirectToLogin();
    //                         }
    //                     }
    //                 }).catch(error => {
    //                     this.setState({ isLoading: false, errorMsg: error });
    //                 });
    //         } catch (error) {
    //             this.setState({ isLoading: false, errorMsg: error });
    //         }
    //     }
    // }


    handleChangeTab = (type) => {
        const { startDate, endDate } = this.state;
        Utilities.LogPrint("Type", type);
        this.setState({
            activeTab: type,
        });

        switch (type) {
            case DashboardType.USERS:
                this.getDashboardUserData(startDate, endDate);
                break;

            case DashboardType.TEHSILS:
                this.getDashboardTehsilData(startDate, endDate);
                break;

            case DashboardType.HYBRID:
                const { data } = this.state;
                if (data?.hybrid_array) {
                    const hybridId = data?.hybrid_array[0]?.hybrid_id;
                    this.getDashboardHybridData(startDate, endDate, hybridId);
                }
                break;

            default:
                break;
        }
    }


    getActiveTabData = () => {
        const { activeTab, startDate, endDate } = this.state;
        switch (activeTab) {
            case DashboardType.ACTIVITIES:
                this.getDashboardActivityData(startDate, endDate);
                break;

            case DashboardType.USERS:
                this.getDashboardUserData(startDate, endDate);
                break;

            case DashboardType.TEHSILS:
                this.getDashboardTehsilData(startDate, endDate);
                break;

            case DashboardType.HYBRID:
                const { data } = this.state;
                if (data?.hybrid_array) {
                    const hybridId = data?.hybrid_array[0]?.hybrid_id;
                    this.getDashboardHybridData(startDate, endDate, hybridId);
                }
                break;

            default:
                break;
        }
    }

    handleSelect(ranges) {
        this.startDate = moment(ranges.startDate).format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
        this.endDate = moment(ranges.endDate).format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);

        this.setState({
            selectionRange: {
                startDate: ranges.startDate,
                endDate: ranges.endDate,
                key: ranges.key
            },
            startDate: ranges.startDate,
            endDate: ranges.endDate
        });
    }

    resetDates = () => {
        this.setState({
            selectionRange: {
                startDate: new Date(),
                endDate: new Date(),
                key: "selection"
            }
        });
    }

    setDateRange = (type) => {
        let startDate, endDate;
        switch (type) {
            case 0:
                startDate = moment().subtract(1, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                endDate = moment().subtract(1, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                Utilities.LogPrint("Yesterday: - ", startDate + " " + endDate);
                this.setState({
                    selectedDateOption: DASHBOARD_SCREEN.YESTERDAY,
                    startDate: startDate,
                    endDate: endDate
                });
                break;
            case 1:
                startDate = moment().subtract(7, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                endDate = moment().subtract(0, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                Utilities.LogPrint("Last 7 Days: - ", startDate + " " + endDate);
                this.setState({
                    selectedDateOption: DASHBOARD_SCREEN.LAST_7_DAYS,
                    startDate: startDate,
                    endDate: endDate
                });
                break;
            case 2:
                startDate = moment().subtract(30, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                endDate = moment().subtract(0, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                Utilities.LogPrint("Last 30 Days: -", startDate + " " + endDate);
                this.setState({
                    selectedDateOption: DASHBOARD_SCREEN.LAST_30_DAYS,
                    startDate: startDate,
                    endDate: endDate
                });
                break;
            default:
                //const { startDate, endDate } = this.state;
                startDate = this.state.startDate;
                endDate = this.state.endDate;
                Utilities.LogPrint("Custom Range: - ", this.state.startDate + " " + this.state.endDate);
                this.setState({
                    selectedDateOption: DASHBOARD_SCREEN.CUSTOM_RANGE,
                    startDate: startDate,
                    endDate: endDate
                });
                //this.resetDates();
                break;
        }
        //this.getDashboardData(startDate, endDate);
        this.getDashboardMasterData(startDate, endDate);
    }

    handleSelectTM = (user) => {
        Utilities.LogPrint(user);

        const { startDate, endDate } = this.state;
        this.role_id = user?.value;
        this.role_name = user?.label;
        //this.getDashboardData(sDate, eDate);
        this.getDashboardMasterData(startDate, endDate);

        //this.setState({ selectedTM: user.name })
    }

    handleCheckboxChange = event => {
        Utilities.LogPrint("Checked", event.target.checked);
        Utilities.LogPrint("Options:-", event.target.value);

        let downloadOptions = this.state.downloadOptions;
        downloadOptions.forEach(option => {
            if (option.value === event.target.value) {
                option.isChecked = event.target.checked
            }
        })

        const selectedOptions = downloadOptions.filter(option => option.isChecked);
        if (selectedOptions.length > 0) {
            this.setState({
                downloadOptions: downloadOptions,
                disableNextButton: false
            });
        } else {
            this.setState({ disableNextButton: true });
        }
    }

    handleNext = (e) => {
        Utilities.LogPrint("Selected Download Options", this.state.downloadOptions);
    }

    handleDateRangeSelection = (type) => {
        //let startDate, endDate;
        Utilities.LogPrint("Range Type", type);
        this.setState({
            activeRange: type
        })
        switch (type) {
            case RangeType.LAST_MONTH:
                this.startDate = moment().subtract(30, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                this.endDate = moment().subtract(0, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                Utilities.LogPrint(this.startDate + " " + this.endDate);
                break;

            case RangeType.LAST_QUARTER:
                this.startDate = moment().subtract(90, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                this.endDate = moment().subtract(0, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                Utilities.LogPrint(this.startDate + " " + this.endDate);
                break;

            case RangeType.LAST_YEAR:
                this.startDate = moment().subtract(365, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                this.endDate = moment().subtract(0, 'days').format(DATE_FORMATS.DASHBOARD_DATE_FORMAT);
                Utilities.LogPrint(this.startDate + " " + this.endDate);
                break;

            case RangeType.CUSTOM_RANGE:
                break;

            default:
                break;
        }
    }

    downloadCustomRangeReport = () => {
        const { startDate, endDate } = this.state;

        let params = {
            start_date: startDate,
            end_date: endDate,
            role_id: this.role_id
        }
        Utilities.LogPrint("Params", params);
        this.child.generatePDF(params);
        this.setState({ isLoading: true });
        this.resetDates();
    }

    downloadButtonClick = () => {

        if (this.state.activeRange === RangeType.CUSTOM_RANGE) {
            this.setState({ showDatePicker: true });
        } else {
            this.setState({ showDatePicker: false });

            let params = {
                start_date: this.startDate,
                end_date: this.endDate,
                role_id: this.role_id
            }
            Utilities.LogPrint("Params", params);

            if (this.state.downloadOptions[0].isChecked) {
                //Create PPT
                const { data } = this.state;
                let pptx = new pptxgen();
                let dataChartAreaLine = [
                    {
                        name: "Total Activities",
                        labels: ["IV", "SD", "GM", "S2S"],
                        values: [data.activity.individual_visit.total_activity, data.activity.sample_distribution.total_activity, data.activity.group_meeting.total_activity, data.activity.sample_to_sale.total_activity],
                    },
                    {
                        name: "Completed Activities",
                        labels: ["IV", "SD", "GM", "S2S"],
                        values: [data.activity.individual_visit.completed_activity, data.activity.sample_distribution.completed_activity, data.activity.group_meeting.completed_activity, data.activity.sample_to_sale.completed_activity],
                    },
                ];

                Utilities.createWelcomeSlide(pptx);
                Utilities.createDetailedSlide(pptx, data, this.startDate, this.endDate);
                Utilities.createKrishakPrerakSlide(pptx, data);
                Utilities.createUserWiseActivitiesSlide(pptx, data);
                for (var i = 0; i < data.hybrid.length; i++) {
                    Utilities.createCropWiseHybridActivitiesSlide(pptx, data.hybrid[i]);
                }

                Utilities.createActivitiesCompletedSlide(pptx, dataChartAreaLine, data);

                Utilities.createDrillDownSlide(pptx, CALENDER_SCREEN.INDIVIDUAL_VISIT, data.activity.individual_visit.sub_activity, "FFFF00");
                Utilities.createDrillDownSlide(pptx, CALENDER_SCREEN.SAMPLE_DISTRIBUTION, data.activity.sample_distribution.sub_activity, "9e7e43");
                Utilities.createDrillDownSlide(pptx, CALENDER_SCREEN.GROUP_MEET, data.activity.group_meeting.sub_activity, "2599fe");
                Utilities.createDrillDownSlide(pptx, CALENDER_SCREEN.SAMPLE_TO_SALE, data.activity.sample_to_sale.sub_activity, "10823c");

                Utilities.createTehsilDataSlide(pptx, data);

                for (let i = 0; i < data.crop_hyrid.length; i++) {
                    Utilities.createDataTableSlide(pptx, data.crop_hyrid[i]);
                }

                pptx.writeFile({ fileName: 'Dashboard.pptx' });
            }
            if (this.state.downloadOptions[1].isChecked) {
                //Create PDF
                this.child.generatePDF(params);
                this.setState({ isLoading: true });
            }

        }
    }


    handleSyncLoading = (isLoading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", isLoading + tableName);
        this.setState({ isSyncLoading: isLoading, tableName })
    }

    onSaveFile = () => {
        this.setState({ isLoading: false });
    }

    render() {
        const { startDate, endDate, activeTab, data, activityData, userData, tehsilData, hybridData, isLoading, isSyncLoading, tableName } = this.state;
        //Utilities.LogPrint("DATA", data);
        return (
            <div>
                <Header selectedTab={HeaderTypes.DASHBOARD} handleSyncLoading={this.handleSyncLoading} />
                <Footer isActive={0} />

                {/* For Download Dashboard Reports */}
                <div style={{ display: 'none' }}>
                    <PDFReport
                        role_name={this.role_name}
                        ref={instance => { this.child = instance }}
                        onSaveFile={this.onSaveFile} />
                </div>

                <div className="container pt-35 pb-65 dashboard-page">
                    <div className="row">
                        <div className="col-md-5 d-none d-md-block">
                            <h2>{COMMON.DASHBOARD}</h2>
                        </div>

                        <div className="col-md-7">
                            <form>
                                <div className=" d-flex dashbord-right align-items-center">
                                    {this.allTMOptions()}

                                    {this.dateRangeOptions()}

                                    {this.downloadOptions()}

                                    {this.customRangePicker()}
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="row d-md-none">
                        <hr className="w-100 bdr-color-gray" />
                    </div>

                    <div className="row mt-0 mt-md-4">
                        <div className="col-md-5 d-flex">
                            <div className="icon-person d-flex align-items-center">
                                <i className="krishak-img general"></i>
                                <div className="ml-3 mr-4">
                                    <p className="mb-0">{DASHBOARD_SCREEN.NEW_KRISHAK}</p>
                                    <p className="mb-0"><b>{data.new_krishak}</b></p>
                                </div>
                            </div>
                            <div className="icon-person d-flex align-items-center">
                                <i className="krishak-img prerak"></i>
                                <div className="ml-3 mr-4">
                                    <p className="mb-0">{DASHBOARD_SCREEN.NEW_PRERAK}</p>
                                    <p className="mb-0"><b>{data.new_prerak}</b></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row d-md-none">
                        <hr className="w-100 bdr-color-gray" />
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <ul className="more-menu dashboard-menu mt-0 mt-md-4">
                                <li className={activeTab === DashboardType.ACTIVITIES ? "active" : ""} data-tab="activities" onClick={() => { this.handleChangeTab(DashboardType.ACTIVITIES) }}>Activities <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeTab === DashboardType.USERS ? "active" : ""} data-tab="users" onClick={() => { this.handleChangeTab(DashboardType.USERS) }}>Users <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeTab === DashboardType.TEHSILS ? "active" : ""} data-tab="tehsils" onClick={() => { this.handleChangeTab(DashboardType.TEHSILS) }}>Tehsils<i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeTab === DashboardType.HYBRID ? "active" : ""} data-tab="hybrids" onClick={() => { this.handleChangeTab(DashboardType.HYBRID) }}> Hybrids <i className="customic ic-go-button ml-auto"></i></li>
                            </ul>
                        </div>
                        <div className="col-md-8 gray-bg-mobile pt-3 pt-md-0">
                            {/* Activites */}
                            <DashboardActivity activities={activityData} activeTab={activeTab} />

                            {/* Users */}
                            <DashboardUsers userActivity={userData} activeTab={activeTab} />

                            {/* Tehsil */}
                            <DashboardTehsils tehsil={tehsilData} activeTab={activeTab} />

                            {/* Hybrids */}
                            <DashboardHybrids
                                hybrids={data?.hybrid_array}
                                hybridData={hybridData}
                                activeTab={activeTab}
                                onHybridChange={(hybrid) => {
                                    this.setState({ hybridData: null })
                                    this.getDashboardHybridData(startDate, endDate, hybrid);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <DesktopFooter />
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                {isLoading ? <Loader /> : null}

            </div>

        )
    }

    allTMOptions = () => {
        const { allTMUsers } = this.state;
        return (
            <div className={`form-grop ${allTMUsers.length === 1 ? 'd-none' : ''}`}>
                <Select className="max-w-360 width-182"
                    onChange={this.handleSelectTM}
                    options={allTMUsers}
                    placeholder="Select the TM"
                    isClearable={false}
                />
            </div>
        )
    }

    dateRangeOptions = () => {
        const { selectedDateOption } = this.state;
        return (
            <div className="form-grop ml-2 ml-md-3">
                <div className="dropdown">
                    <button className="btndropdown-toggle btn btn-dropdown w-182 align-items-center d-none d-md-flex" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="customic ic-datepicker mb-1 mr-3"></i> {selectedDateOption}
                    </button>
                    <div className="dropdown-menu custom-dropdown" aria-labelledby="dropdownMenuButton2">
                        <a className="dropdown-item dropdown-item-title">{DASHBOARD_SCREEN.SELECT_DATE_RANGE}</a>
                        <a className="dropdown-item" onClick={() => this.setDateRange(0)}>{DASHBOARD_SCREEN.YESTERDAY}</a>
                        <a className="dropdown-item" onClick={() => this.setDateRange(1)}>{DASHBOARD_SCREEN.LAST_7_DAYS}</a>
                        <a className="dropdown-item" onClick={() => this.setDateRange(2)}>{DASHBOARD_SCREEN.LAST_30_DAYS}</a>
                        <a className="dropdown-item" href="#" data-toggle="modal" data-target="#customDateRangDrawer">{DASHBOARD_SCREEN.CUSTOM_RANGE}</a>
                    </div>

                    <button className="btndropdown-toggle btn btn-dropdown w-182 d-flex d-md-none align-items-center" type="button" data-toggle="modal" data-target="#dropdownMenuButtonDrawers">
                        <i className="customic ic-datepicker mb-1 mr-3"></i> {selectedDateOption}
                    </button>

                    {/* bottom drawers dropdownMenuButton*/}
                    <div className="modal fade bottom-drawer" id="dropdownMenuButtonDrawers" role="dialog" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">

                                    <h6 className="font-weight-medium">{DASHBOARD_SCREEN.SELECT_DATE_RANGE}</h6>
                                    <ul className="drawer-menu-list">
                                        <li><a onClick={() => this.setDateRange(0)} data-dismiss="modal">{DASHBOARD_SCREEN.YESTERDAY}</a></li>
                                        <li><a onClick={() => this.setDateRange(1)} data-dismiss="modal">{DASHBOARD_SCREEN.LAST_7_DAYS}</a></li>
                                        <li><a onClick={() => this.setDateRange(2)} data-dismiss="modal">{DASHBOARD_SCREEN.LAST_30_DAYS}</a></li>
                                        <li><a data-dismiss="modal" data-toggle="modal" data-target="#customDateRangDrawer">{DASHBOARD_SCREEN.CUSTOM_RANGE}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* bottom drawers customDateRangDrawer */}
                    <div className="modal fade bottom-drawer" id="customDateRangDrawer" role="dialog" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <h6 className="font-weight-medium mt-2 d-md-none">Select Custom Range</h6>
                                    <div className="custom-date-rang">
                                        <DateRangePicker
                                            onChange={item => this.handleSelect(item.selection)}
                                            showSelectionPreview={true}
                                            moveRangeOnFirstSelection={false}
                                            months={2}
                                            ranges={[this.state.selectionRange]}
                                            direction="vertical"
                                            maxDate={new Date()}
                                        />
                                    </div>
                                    <div className="col-12 d-flex button-grp-bottom py-2">
                                        <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" >{COMMON.CANCEL}</button>
                                        <button className="btn btn-primary w-50" data-dismiss="modal" onClick={() => this.setDateRange(3)}>{COMMON.OK}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    downloadOptions = () => {
        const { downloadOptions } = this.state;
        const showDownload = AuthService.getRoleAccess(PERMISSION_CONSTANTS.DASHBOARD_DOWNLOAD);
        return (
            <div className="form-grop download-btn ml-2 ml-md-3">
                {showDownload?.view ?
                    <a className="d-md-none" data-toggle="modal" data-target="#selectDownloadFile">
                        <i className="customic ic-download mt-1"></i>
                    </a> : null
                }

                {/* <button className="btndropdown-toggle btn btn-primary align-items-center justify-content-center w-182 d-none d-md-flex" type="button" id="downloadFileDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Download</button> */}
                {showDownload?.view ?
                    <button className="btndropdown-toggle btn btn-primary align-items-center justify-content-center w-182 d-none d-md-flex" type="button" data-toggle="modal" data-target="#selectDownloadFile">
                        {COMMON.DOWNLOAD}
                    </button> : null
                }



                {/* bottom drawers Download*/}
                <div className="modal fade bottom-drawer" id="selectDownloadFile" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body pb-65 pb-md-3">
                                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h6 className="font-weight-medium">{DASHBOARD_SCREEN.SELECT_ITEMS_DOWNLOAD}</h6>
                                <ul className="selectbox-list">
                                    {
                                        downloadOptions.map((item, i) =>
                                            <li key={i}>
                                                <label className="cutom-checkbox-container">{item.value}
                                                    <input type="checkbox" value={item.value} onChange={this.handleCheckboxChange} />
                                                    <span className="checkmark"></span>
                                                </label>
                                            </li>
                                        )
                                    }
                                </ul>
                                <div className="col-12 d-flex button-grp-bottom py-2 px-md-0">
                                    <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal">{COMMON.CANCEL}</button>
                                    <button disabled={this.state.disableNextButton} className="btn btn-primary w-50" data-dismiss="modal" data-toggle="modal" data-target="#downloadRange" onClick={() => { this.handleNext() }}>{COMMON.NEXT}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Desktop Download Date Range Options Popup */}
                <div className="modal fade bottom-drawer date-range-selectbox-popup" id="dateRangeSelectboxPopup" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h6 className="font-weight-medium">{DASHBOARD_SCREEN.SELECT_DATE_RANGE}</h6>
                                <div className="form-group">
                                    <label className="custom-radio-container mt-3">
                                        {DASHBOARD_SCREEN.LAST_MONTH}
                                        <input type="radio" name="radio" onClick={() => this.handleDateRangeSelection(RangeType.LAST_MONTH)} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="custom-radio-container mt-3">
                                        {DASHBOARD_SCREEN.LAST_QUARTER}
                                        <input type="radio" name="radio" onClick={() => this.handleDateRangeSelection(RangeType.LAST_QUARTER)} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="custom-radio-container mt-3">
                                        {DASHBOARD_SCREEN.LAST_YEAR}
                                        <input type="radio" name="radio" onClick={() => this.handleDateRangeSelection(RangeType.LAST_YEAR)} />
                                        <span className="checkmark"></span>
                                    </label>
                                    <label className="custom-radio-container mt-3">
                                        {DASHBOARD_SCREEN.CUSTOM_RANGE}
                                        <input type="radio" name="radio" onClick={() => this.handleDateRangeSelection(RangeType.CUSTOM_RANGE)} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>

                                <div className="d-flex">
                                    <button className="btn btn-secondary w-50">{COMMON.CANCEL}</button>
                                    <button type="button" className="btn btn-primary w-50 ml-3" data-dismiss="modal" data-toggle="modal" data-target={this.state.showDatePicker ? "#customDateRangPicker" : ""}
                                        onClick={() => { this.downloadButtonClick() }}>
                                        {COMMON.DOWNLOAD}
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Bottom Download Date Range Options Popup */}
                <div className="modal fade bottom-drawer show" id="downloadRange" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body pb-65 pb-md-3">
                                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h6 className="font-weight-medium">{DASHBOARD_SCREEN.SELECT_DATE_RANGE}</h6>
                                <ul className="drawer-menu-list">
                                    <li className={this.state.activeRange === RangeType.LAST_MONTH ? 'active' : ''}>
                                        <a onClick={() => this.handleDateRangeSelection(RangeType.LAST_MONTH)}>{DASHBOARD_SCREEN.LAST_MONTH}</a>
                                    </li>
                                    <li className={this.state.activeRange === RangeType.LAST_QUARTER ? 'active' : ''}>
                                        <a onClick={() => this.handleDateRangeSelection(RangeType.LAST_QUARTER)}>{DASHBOARD_SCREEN.LAST_QUARTER}</a>
                                    </li>
                                    <li className={this.state.activeRange === RangeType.LAST_YEAR ? 'active' : ''}>
                                        <a onClick={() => this.handleDateRangeSelection(RangeType.LAST_YEAR)}>{DASHBOARD_SCREEN.LAST_YEAR}</a>
                                    </li>
                                    <li className={this.state.activeRange === RangeType.CUSTOM_RANGE ? 'active' : ''}>
                                        <a onClick={() => this.handleDateRangeSelection(RangeType.CUSTOM_RANGE)}>{DASHBOARD_SCREEN.CUSTOM_RANGE}</a>
                                    </li>
                                </ul>
                                <div className="col-12 d-flex button-grp-bottom py-2 px-md-0 pt-md-3">
                                    <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal">{COMMON.CANCEL}</button>
                                    <button id="download" className="btn btn-primary w-50" data-dismiss="modal" data-toggle="modal" data-target={this.state.showDatePicker ? "#customDateRangPicker" : ""}
                                        onClick={() => { this.downloadButtonClick() }}>
                                        {COMMON.DOWNLOAD}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    customRangePicker = () => {
        return (
            <div className="modal fade bottom-drawer" id="customDateRangPicker" role="dialog" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h6 className="font-weight-medium mt-2 d-md-none">Select Custom Range</h6>
                            <div className="custom-date-rang">
                                <DateRangePicker
                                    onChange={item => this.handleSelect(item.selection)}
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={[this.state.selectionRange]}
                                    direction="vertical"
                                    maxDate={new Date()}
                                // monthDisplayFormat={"MMMM-yyyy"}
                                />
                            </div>
                            <div className="col-12 d-flex button-grp-bottom py-2">
                                <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" >{COMMON.CANCEL}</button>
                                <button className="btn btn-primary w-50" data-dismiss="modal" onClick={() => this.downloadCustomRangeReport()}>{COMMON.DOWNLOAD}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(DashboardPage);